import Axios from "axios";

const SOLANA_BASE58_REGEX = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
const ETHEREUM_HEX_REGEX = /^0x[a-fA-F0-9]{40}$/;

export const isValidSolanaAddressFormat = (address) => {
    if (typeof address !== "string") return false;
    return SOLANA_BASE58_REGEX.test(address.trim());
};

export const isValidEthereumAddressFormat = (address) => {
    if (typeof address !== "string") return false;
    return ETHEREUM_HEX_REGEX.test(address.trim());
};

export const isValidWalletAddress = (chain, address) => {
    const normalizedChain = String(chain || "solana")
        .trim()
        .toLowerCase();
    if (normalizedChain === "ethereum" || normalizedChain === "eth") {
        return isValidEthereumAddressFormat(address);
    }
    return isValidSolanaAddressFormat(address);
};

export const formatShortAddress = (address = "") => {
    const str = String(address || "").trim();
    if (str.length <= 12) return str;
    return `${str.slice(0, 6)}…${str.slice(-4)}`;
};

export const fetchOnChainWallet = async (
    chain,
    address,
    { currency = "USD", refresh = false } = {}
) => {
    const normChain =
        String(chain || "solana")
            .trim()
            .toLowerCase() === "ethereum"
            ? "ethereum"
            : "solana";
    const trimmed = String(address || "").trim();
    const baseUrl = process.env.REACT_APP_API || "https://api.rajchandra.me";
    const response = await Axios.get(
        `${baseUrl}/wallets/${normChain}/${encodeURIComponent(trimmed)}`,
        {
            params: {
                currency,
                ...(refresh ? { refresh: "1" } : {}),
            },
            withCredentials: true,
        }
    );
    return response.data;
};

export const detectBrowserWalletAddress = async (chain = "solana") => {
    if (typeof window === "undefined") return null;
    const normChain = String(chain || "solana")
        .trim()
        .toLowerCase();

    if (normChain === "ethereum" || normChain === "eth") {
        const provider = window.ethereum;
        if (!provider || typeof provider.request !== "function") {
            return null;
        }
        const accounts = await provider.request({
            method: "eth_requestAccounts",
        });
        if (Array.isArray(accounts) && accounts.length > 0) {
            return String(accounts[0]).trim();
        }
        return null;
    }

    const solProvider = window.solana || window.phantom?.solana;
    if (!solProvider || typeof solProvider.connect !== "function") {
        return null;
    }
    const resp = await solProvider.connect();
    const pubKey =
        resp?.publicKey?.toString?.() ||
        solProvider.publicKey?.toString?.() ||
        null;
    return pubKey ? String(pubKey).trim() : null;
};
